import styled from "styled-components";
import { HeadLine2 } from "../components/typography/styled";


type ActiveProp = {
  isSmall?:boolean
}

export const PageWrapper = styled.div<ActiveProp>`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100vh;
  box-sizing: border-box;

  .react-loading-skeleton {
    max-width: 100%;
  }

  @media (max-width: 768px) {
    overflow-x: clip;
  }
`

export const RouterWrapper = styled.div`
  background-color: ${({theme}) => theme.base.white};
  display: flex;
  justify-content: flex-start;
  width: 100%;
  min-width: 0;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const Link = styled(HeadLine2)`
  &:hover{
    cursor: pointer;
  }
  color:${({theme}) => theme.primary[600]};
  border-radius:4px;
  margin: 10px;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30%;
  height:100vh;
`
export const LinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
`
